import { render, staticRenderFns } from "./PhoneNumberForm.vue?vue&type=template&id=767dc4ac&scoped=true&"
import script from "./PhoneNumberForm.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberForm.vue?vue&type=script&lang=js&"
import style0 from "./PhoneNumberForm.vue?vue&type=style&index=0&id=767dc4ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767dc4ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VBtnToggle,VCard,VCardTitle,VIcon})
